<template>
    <div>
        <portal to="dashboardStatsCards">
            <b-overlay :show="dashboardDataLoading" rounded="lg">
                <b-row class="g-2 g-lg-3 mb-4">
                    <b-col
                        v-for="(item) in statPaths"
                        :key="item.name"
                        lg="3"
                        md="6"
                        sm="6"
                        cols="12"
                        class="grid-margin mb-0"
                        ref="gridItems"
                    >
                        <router-link
                            v-if="
                                item.name == 'orders' || isPermitted(item.name)
                            "
                            class="text-decoration-none"
                            :to="item.path"
                        >
                            <stats-card
                                :title="item.title"
                                :dashboardHeight="{ height: cardHeight }"
                                :type="item.color"
                                :sub-title="item.subTitle"
                                :icon-name="getIconName(item.name)"
                                :iconColor="item.iconColor"
                                :img="item.img"
                                :count="item.count"
                            ></stats-card>
                        </router-link>
                        <stats-card
                            v-else
                            :title="item.title"
                            :type="item.color"
                            :sub-title="item.subTitle"
                            :icon-name="getIconName(item.name)"
                            :img="item.img"
                            :count="item.count"
                        ></stats-card>
                    </b-col>
                </b-row>
                <Analytics />
            </b-overlay>
        </portal>
    </div>
</template>
<script>
import layoutMixins from '../mixins/layoutMixins'
import { capitalCase } from 'change-case'
import Analytics from './Analytics.vue'
import StatsCard from '@/components/StatsCard.vue'
import usersImg from '@/assets/images/icon/users.svg'
import customerImg from '@/assets/images/icon/customer.svg'
import locationImg from '@/assets/images/icon/location.svg'
import activitiesImg from '@/assets/images/icon/activities.svg'

export default {
    components: {
        Analytics,
        StatsCard,
    },
    mixins: [layoutMixins],
    data() {
        return {
            cardHeight: 'auto',
        }
    },
    methods: {
        calculateItemHeights() {
            const gridItemsRefs = this.$refs.gridItems
            if (gridItemsRefs) {
                let maxHeight = 0
                gridItemsRefs.forEach(gridItemRef => {
                    const gridItemHeight = gridItemRef.clientHeight
                    console.log(gridItemHeight, 'calculateItemHeights')
                    maxHeight = Math.max(maxHeight, gridItemHeight)
                })
                this.cardHeight = `${maxHeight}px`
            }
        },
        triggerResizeEvent() {
            window.dispatchEvent(new Event('resize'))
        },
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },
    async created() {
        // this.calculateItemHeights();
        await Promise.all([
            this.$store.dispatch('users/fetchAll'),
            this.$store.dispatch('company/fetch'),
            this.$store.dispatch('analytics/getDashboardData'),
        ])
        this.loaded = true
    },

    computed: {
        dashboardDataLoading() {
            return this.$store.state.analytics.dashboardDataLoading
        },

        size() {
            return this.idx < this.statPaths.length - 1
                ? parseInt(12 / this.statPaths.length)
                : ''
        },
        filteredOfficers() {
            return this.officers
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        officers() {
            return this.$store.getters['analytics/officers']
        },
        crmSettingValue() {
            return this.$store.getters['company/crmSettingValue']
        },
        user() {
            return this.$store.state.user || {}
        },
        roles() {
            return this.$store.getters['analytics/roles']
        },
        assets() {
            return this.$store.getters['analytics/assets']
        },
        assetTypes() {
            return this.$store.getters['analytics/assetTypes']
        },
        orders() {
            console.log(
                this.$store.getters['analytics/orders'],
                'analytics/orders'
            )
            return this.$store.getters['analytics/orders']
        },

        orderTypes() {
            return this.$store.getters['analytics/orderTypes']
        },

        orders_cnt() {
            return this.$store.getters['analytics/orders_cnt'] || 0
        },

        crm_cnt() {
            return this.$store.getters['analytics/crm_cnt'] || 0
        },

        asset_cnt() {
            return this.$store.getters['analytics/asset_cnt'] || 0
        },

        customers_cnt() {
            return this.$store.getters['analytics/customers_cnt'] || 0
        },

        statPaths() {
            this.calculateItemHeights()
            return [
                {
                    name: 'orders',
                    path: '/ams/activities',
                    color: 'green-shade',
                    title: this.$translate('activities'),
                    iconColor: 'color_3',
                    img: activitiesImg,
                    subTitle: 'Activities',
                    count: this.orders_cnt.toString(),
                },
                {
                    name: 'customers',
                    path: '/ams/customers',
                    color: 'blue-shade',
                    title: this.$translate('customers'),
                    iconColor: 'color_1',
                    img: customerImg,
                    subTitle: 'Customers',
                    count: this.customers_cnt.toString(),
                },
                {
                    name: 'crmSchedule',
                    path: '/ams/crm-schedule',
                    color: 'bg-gradient-danger',
                    title: this.$translate('crm_schedule'),
                    iconColor: 'colorn',
                    img: usersImg,
                    subTitle: 'Users',
                    count: this.crm_cnt.toString(),
                },

                {
                    name: 'assetSchedule',
                    path: '/ams/asset-schedule',
                    color: 'brown-shade',
                    title: this.$translate('asset_schedule'),
                    iconColor: 'color_2',
                    img: locationImg,
                    subTitle: 'Locations/Warehouses',
                    count: this.asset_cnt,
                },
            ]
        },
    },
    watch: {
        cardHeight() {
            this.calculateItemHeights()
        },
    },
}
</script>
